import React from 'react'
import CheckIcon from '@mui/icons-material/Check';
import RemoveIcon from '@mui/icons-material/Remove';
import logo from "assets/images/king.png";
import LogoBilling from "assets/images/logo_blanco_billing.png";
import { useSelector } from 'react-redux';

const PACK_ENTREPRENEUR = 6

const FeaturesPlan = props => {
  const pack = useSelector(state => state.planes.pack)

  return (
    <div className="step-feature-plan">
      <div >
        <br />
        <table className="tableFeaturePlan">
          <tbody>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen_left`}>Usuarios</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Gratis</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Lite</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Estándar</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}>Pro</td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Usuarios ilimitados</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Gestión de Permisos y Perfiles</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
          </tbody>
        </table>
        <hr className={`itemFeatureLine`} />
        <table className="tableFeaturePlan">
          <tbody>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen_left`}>Ventas & Clientes</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Gratis</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Lite</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Estándar</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}>Pro</td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Gestión de Ventas</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Ventas con Adelantos</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Lista de Precios diferenciados</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Descuentos y promociones</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Geolocalización de Clientes</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Geolocalización de Pedidos</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
          </tbody>
        </table>
        <hr className={`itemFeatureLine`} />
        <table className="tableFeaturePlan">
          <tbody>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen_left`}>Compras & Inventario</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Gratis</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Lite</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Estándar</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}>Pro</td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Gestión de Compras</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Gestión de Inventario</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Costeo de Inventario</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Control en Traspaso de Almacenes</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Sugerencia de Inventario</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
          </tbody>
        </table>
        <hr className={`itemFeatureLine`} />
        <table className="tableFeaturePlan">
          <tbody>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen_left`}>Cuentas por Cobrar & Pagar</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Gratis</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Lite</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Estándar</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}>Pro</td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Gestión de Cuentas por Pagar</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Gestión de Cuentas por Cobrar</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
          </tbody>
        </table>

        <hr className={`itemFeatureLine`} />

        <table className="tableFeaturePlan">
          <tbody>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen_left`}>Reportes</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Gratis</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Lite</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Estándar</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}>Pro</td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Reportes de Ventas</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Reportes para toma de decisiones</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Reportes Avanzados</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
          </tbody>
        </table>

        <hr className={`itemFeatureLine`} />
        <table className="tableFeaturePlan">
          <tbody>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen_left`}>Atención al Cliente</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Gratis</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Lite</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Estándar</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}>Pro</td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Soporte</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}>WhatsApp y Línea Gratuita</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}>WhatsApp y Línea Gratuita</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}>WhatsApp y Línea Gratuita</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}>WhatsApp y Línea Gratuita</td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Pack de Asesoría</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleBlue`}>Más info</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleBlue`}>Más info</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleBlue`}>Más info</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleBlue`}>Más info</td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Sesiones de Seguimiento</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Ninguna</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>1 x Mes</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>2 x Mes</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>1 x Semana</td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Manuales</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Agente de Experiencia Dedicado</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Prioridad en Soporte</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}>
              {
                pack === PACK_ENTREPRENEUR ? <img style={{ objectFit: 'cover', maxWidth: "150px"  }} src={LogoBilling} alt="tugerenteBilling" /> :   <img alt="tuGerente logo" src={logo} style={{ maxWidth: "40px" }} />
              }

              </td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Sesión de Kick-off</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
          </tbody>
        </table>

        <hr className={`itemFeatureLine`} />
        <table className="tableFeaturePlan">
          <tbody>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen_left`}>Gastos & Presupuestos</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Gratis</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Lite</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Estándar</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}>Pro</td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Gestión de Gastos</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Presupuesto de Gastos</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Gastos futuros</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Gestión de Caja Chica</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
          </tbody>
        </table>

        <hr className={`itemFeatureLine`} />
        <table className="tableFeaturePlan">
          <tbody>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen_left`}>Recetas & Producción</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Gratis</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Lite</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Estándar</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}>Pro</td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Manejo de Recetas y Producción</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
          </tbody>
        </table>

        <hr className={`itemFeatureLine`} />
        <table className="tableFeaturePlan">
          <tbody>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen_left`}>Integraciones</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Gratis</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Lite</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}>Estándar</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}>Pro</td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Tiendas Online</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}>Acceso a API Rest</td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
            <tr>
              <td className={`itemFeaturePlan itemFeaturePlan--left`}> Webhooks</td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan`}><RemoveIcon /></td>
              <td className={`itemFeaturePlan itemFeaturePlan--titleGreen`}><CheckIcon /></td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  )
}

export default FeaturesPlan
